// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconEmailSent_loader__1O4sA","root":"IconEmailSent_root__3crHG"};